import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { requestCancelReservation } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import useMainContext from "utils/context/useMainContext";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { TOAST_MESSAGES } from "../../RegularReservationActivity/RegularReservationView/utils/constants";
import { wait } from "utils/others";

const useCancelSpaceReservation = ({
	updateActivityPopup, reservation, 
    reservationType
}) => {
	const mainContext = useMainContext();
	const { 
        loadingRequestOfReservationAction, 
        toastMessage, spaceList 
    } = useResourcesUniversitySpacesContext();
	const dialogCancelReservation = useShowDialogAlert();
	async function cancelReservation() {
        dialogCancelReservation.hide();
        loadingRequestOfReservationAction.show("Cancelando reserva...");
        const success = await requestCancelReservation({
            reservationId: reservation.id,
            reservationType
        });
        loadingRequestOfReservationAction.hide();
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        updateActivityPopup.popup.hide();
        await wait(220);
        toastMessage.show(TOAST_MESSAGES.CANCEL_RESERVATION);
        spaceList.reservations.remove(reservation, reservationType);
    }
	return {
        dialogCancelReservation, cancelReservation
    };
}	
	
export default useCancelSpaceReservation;